/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Insights_Details_BodyInputs */

const en_why_listening_insights_details_body = /** @type {(inputs: Why_Listening_Insights_Details_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authors, source and category at a glance.`)
};

const es_why_listening_insights_details_body = /** @type {(inputs: Why_Listening_Insights_Details_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autores, fuente y categoría de un vistazo.`)
};

/**
* | output |
* | --- |
* | "Authors, source and category at a glance." |
*
* @param {Why_Listening_Insights_Details_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_insights_details_body = /** @type {((inputs?: Why_Listening_Insights_Details_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Insights_Details_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_insights_details_body(inputs)
	return en_why_listening_insights_details_body(inputs)
});